import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { Image } from "react-bootstrap";
import {
	Col,
	Row,
	Input,
	Button,
	ButtonGroup,
	Table,
	InputGroup,
	InputGroupAddon,
	FormGroup,
} from "reactstrap";
import CustomReactSelect from "../../components/CustomReactSelect";
import "./SptimesheetStyle.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faChevronRight,
	faChevronLeft,
	faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import { UserConsumer } from "../../UserContext";
import { Timesheet_APIs } from "./Timesheet_API";
import axios from "axios";
import cmntImg from "../../images/comment.svg";
import filledCommentImg from "../../images/filledComment.svg";
import Comment from "./ViewComment";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Timesheet_Variables } from "./timesheet_Variables";
import Header from "./Header";
import Spinner from "reactstrap/lib/Spinner";
import { devOpsHoursToTime } from "../../utils";
import Label from "reactstrap/lib/Label";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import {
	UpdateNavBarItem,
	UpdateNavBarTab,
} from "../../components/navbarRedux/action";
import { AlertPopups } from "../../components/AlertPopups";
import DevOpsTasksModal from "./DevOpsTasksModal";
import { Routes } from "../../configurations/config";
import { APIDateFormat } from "../Dashboard/DashboardVariables";

import homeIcon from "../../images/icons/homeIcon.png";
import officeIcon from "../../images/icons/officeIcon.png";
let token,
	empID,
	empDesignation = null;
class SpTimesheet extends Component {
	constructor(props) {
		super(props);
		this.state = {
			totalHoursThisWeek: 0,
			perdayHours: [],
			hoursPerProjectPerDay: [],
			employee: [],
			datePicker: new Date(),
			Comments: "",
			disabled: false,
			date: new Date(),
			employeeList: [],
			joiningDate: new Date(),
			noDataFlag: true,
			allProjects: [],
			noOfprojects: "",
			status: "",
			currentTimesheetDate: new Date(),
			weekDates: [],
			taskName: "",
			commentDate: "",
			empComments: "",
			CommentsErr: "",
			noRecord: false,
			showLoader: false,
			selectedName: "",
			rejectionReasonIfAny: "",
			statusId: null,
			devOpsModal: false,
			devOpsTasksData: null,
			devOpsDate: null,
			weekHolidayData: [],
		};
	}

	componentDidMount() {
		let params = new URLSearchParams(window.location.search);
		let week = params.get("week");
		let emp = params.get("emp");
		this.getEmployeesList(week, emp);
		
		//this.getTimesheet();
		if (week && emp) {
			this.getEmployeeLeavesAndPublicHolidays(emp,week);
			this.props.UpdateNavBarItem("SpTimeSheetStatus");
			this.props.UpdateNavBarTab("SupervisorTasks");
			sessionStorage.setItem("NavbarTab", "SupervisorTasks");
			sessionStorage.setItem("NavbarItem", "SpTimeSheetStatus");
		}
	}
	getWorkstationForDate(date) {
		
		const matchingRecord = this.state.weekHolidayData.find(record =>
			moment.utc(record.date).isSame(moment.utc(date), 'day')
		);
	  
		// If a matching record is found, return its workstation value; otherwise, return null or a default value
		return matchingRecord ? matchingRecord.workStation : null;
	  }
	getEmployeesList = (week, emp) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};

		if (
			empID.toString() === "180" ||
			empID.toString() === "232" ||
			empDesignation.toString() === "4"
		)
			axios
				.get(`${Timesheet_APIs.GetAllEmployees_API}`, {
					headers: headers,
				})
				.then((res) => {
					if (res.status === 200) {
						let data = res.data;
						if (week && emp) {
							let employeeId = parseInt(emp);
							let empObject = data.find((obj) => {
								return obj.employeeId === employeeId;
							});
							let employee = {
								value: empObject.employeeId,
								label: empObject.name,
							};
							this.setState({
								datePicker: new Date(week),
								employee: employee,
								selectedName: employee.label,
							});
							this.getTimesheetDate(week, employee);
						}

						this.setState({
							employeeList: data.sort((a, b) =>
								a.name.localeCompare(b.name)
							),
						});
					}
				});
		else
			axios
				.get(`${Timesheet_APIs.GetSupervisorEmployees_API}`, {
					headers: headers,
				})
				.then((res) => {
					if (res.status === 200) {
						let data = res.data;
						if (week && emp) {
							let employeeId = parseInt(emp);
							let empObject = data.find((obj) => {
								return obj.employeeId === employeeId;
							});
							let employee = {
								value: empObject.employeeId,
								label: empObject.name,
							};
							this.setState({
								datePicker: new Date(week),
								employee: employee,
								selectedName: employee.label,
							});
							this.getTimesheetDate(week, employee);
						}

						this.setState({
							employeeList: data.sort((a, b) =>
								a.name.localeCompare(b.name)
							),
						});
					}
				});
	};
	openDatepicker = () => this._calendar.setOpen(true);
	employees() {
		return this.state.employeeList.map((data) => ({
			label: data.name,
			value: data.employeeId,
			joiningDate: new Date(data.joiningDate),
		}));
	}
	validateForm = () => {
		let valid = true;
		this.state.CommentsErr && (valid = false);
		return valid;
	};
	handleCommentsChange = (temp, displayCode) => {
		if (displayCode === 1) {
			let CommentsErr = this.state.CommentsErr;
			CommentsErr =
				temp.target.value.length > 500
					? "Max 500 characters allowed"
					: "";
			this.setState({
				//Supervisor Comments
				[temp.target.name]: temp.target.value,
				CommentsErr,
			});
		}
	};
	handleSubmit = () => {
		if (this.validateForm()) {
			AlertPopups.confirmBox
				.fire({
					text: `${Timesheet_Variables.TimesheetAcceptConfirm}`,
				})
				.then((result) => {
					if (result.value) {
						this.approveTimesheet();
					}
				});
		}
	};
	approveTimesheet = () => {
		let self = this;
		let data = {
			employeeId: this.state.employee.value,
			supervisorComment: this.state.Comments,
			submittedDate: moment(this.state.datePicker).format(APIDateFormat),
			timeSheetStatus: 4, //Accept timesheet
		};
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.put(`${Timesheet_APIs.ApproveRejectTimeSheet_API}`, data, {
				headers: headers,
			})
			.then(function (response) {
				if (response.status === 200) {
					AlertPopups.successAlert.fire({
						text: `${Timesheet_Variables.acceptTimesheetMsg}`,
					});
					self.getTimesheet();
				}
			})
			.catch(() => {
				AlertPopups.WarningAlert.fire({
					text: `Try again please`,
				});
			});
	};
	hoursToMinutes = (time) => {
		let hms = time;
		let a = hms.split(":");
		let minutes = +a[0] * 60 + +a[1];
		return minutes;
	};
	minutesToHours = (time) => {
		let hours = Math.floor(time / 60);
		let minutes = time % 60;
		let sum = hours + ":" + minutes;
		if (hours <= 23) sum = moment(sum, "HH:mm").format("HH:mm");
		return sum;
	};
	getTimesheet = () => {
		this.getEmployeeLeavesAndPublicHolidays(this.state.employee.value,this.state.datePicker);
		const currentEmp = this.state.employeeList.filter(
			(item) => item.employeeId === this.state.employee.value
		);

		if (
			this.state.datePicker.getTime() > new Date().getTime() ||
			this.state.datePicker.getTime() <
				new Date(currentEmp[0].joiningDate).getTime()
		) {
			if (this.state.datePicker.getTime() > new Date().getTime()) {
				this.setState({ datePicker: new Date().getTime() });
			} else if (
				this.state.datePicker.getTime() <
				new Date(currentEmp[0].joiningDate).getTime()
			) {
				this.setState({
					datePicker: new Date(currentEmp[0].joiningDate).getTime(),
				});
			}
			return;
		}
		this.setState({ showLoader: true });
		let headers = {
				Authorization: `Bearer ${token}`,
			},
			self = this,
			totalHoursThisWeek = 0;
		axios
			.get(
				`${Timesheet_APIs.GetWeeklyTimeSheet_API}${
					this.state.employee.value
				}&Date=${this.state.datePicker.toISOString()}`,
				{
					headers: headers,
				}
			)
			.then(function (response) {
				if (response.data.hoursPerProjectPerDay.length !== 0) {
					let outputarr = [0, 0, 0, 0, 0, 0, 0];
					let newoutputarr = [];
					for (let i in response.data.hoursPerProjectPerDay) {
						for (let j in response.data.hoursPerProjectPerDay[i]
							.details) {
							outputarr[j] += self.hoursToMinutes(
								String(
									response.data.hoursPerProjectPerDay[i]
										.details[j].hours
								)
							);
						}
					}
					for (let i in outputarr) {
						totalHoursThisWeek = totalHoursThisWeek + outputarr[i];
						newoutputarr[i] = self.minutesToHours(outputarr[i]);
					}
					self.setState({
						noDataFlag: false,
						noOfprojects:
							response.data.hoursPerProjectPerDay.length,
						allProjects: response.data.hoursPerProjectPerDay,
						Comments: response.data.supervisorComments,
						status: response.data.status,
						weekDates:
							response.data.hoursPerProjectPerDay[0].details,
						perdayHours: newoutputarr,
						totalHoursThisWeek:
							self.minutesToHours(totalHoursThisWeek),
						noRecord: false,
						showLoader: false,
						statusId: response.data.statusId,
						rejectionReasonIfAny:
							response.data.rejectionReasonIfAny,
					});

					if (response.data.statusId !== 3) {
						self.setState({
							disabled: true,
						});
					} else
						self.setState({
							disabled: false,
						});
				} else
					self.setState({
						noDataFlag: true,
						noRecord: true,
						showLoader: false,
					});
			});
	};
	getEmployeeLeavesAndPublicHolidays = (empId,week) => {
		axios
			.get(
				`${Timesheet_APIs.GetWeekInformation}?EmployeeId=${
					empId
						}&date=${moment(week)
					.weekday(1)
					.format(APIDateFormat)}`
			)
			.then((res) => {
				this.setState({ weekHolidayData: res.data.dateRecords });
			});
	};


	handleClick = (temp) => {
		this.setState({
			selectedName: this.state.employee.label,
		});
		const headers = {
				Authorization: `Bearer ${token}`,
			},
			self = this;
		if (temp === 1) {
			//reject button function
			if (this.validateForm()) {
				AlertPopups.confirmBox
					.fire({
						text: `${Timesheet_Variables.TimesheetRejectConfirm}`,
					})
					.then((result) => {
						if (result.value) {
							const data = {
								employeeId: this.state.employee.value,
								supervisorComment: this.state.Comments,
								submittedDate: moment(
									this.state.datePicker
								).format(APIDateFormat),
								timeSheetStatus: 5,
							};
							axios
								.put(
									`${Timesheet_APIs.ApproveRejectTimeSheet_API}`,
									data,
									{
										headers: headers,
									}
								)
								.then(function (response) {
									if (response.status === 200) {
										AlertPopups.InfoAlert.fire({
											text: `${Timesheet_Variables.rejectTimesheetMsg}`,
										});
										self.getTimesheet();
									}
								})
								.catch((error) => {
									AlertPopups.WarningAlert.fire({
										text: `Try again please`,
									});
								});
						}
					});
			}
		} else {
			if (this.state.employee.length !== 0) {
				if (temp === 2) {
					this.getTimesheet();
				} else if (temp === 3) {
					this.setState(
						(prevState) => ({
							datePicker: new Date(
								moment(prevState.datePicker)
									.subtract(1, "weeks")
									.format(APIDateFormat)
							),
						}),
						() => {
							this.getTimesheet();
						}
					);
				} else if (temp === 4) {
					this.setState(
						(prevState) => ({
							datePicker: new Date(
								moment(prevState.datePicker)
									.add(1, "weeks")
									.format(APIDateFormat)
							),
						}),
						() => {
							this.getTimesheet();
						}
					);
				}
			} else {
				AlertPopups.ErrorAlert.fire({
					text: `Select any employee first`,
				});
			}
		}
	};
	CommentRef = (obj) => {
		this.showModal = obj && obj.handleShow;
	};
	onCommentClick = (taskName, commentDate, empComments) => {
		this.setState({
			taskName: taskName,
			commentDate: commentDate,
			empComments: empComments,
		});
		this.showModal();
	};
	showModal = () => {};

	getTimesheetDate = (week, empObj) => {
		let headers = {
				Authorization: `Bearer ${token}`,
			},
			self = this,
			totalHoursThisWeek = 0;
		axios
			.get(
				`${Timesheet_APIs.GetWeeklyTimeSheet_API}${empObj.value}&Date=${week}`,
				{
					headers: headers,
				}
			)
			.then(function (response) {
				if (response.data.hoursPerProjectPerDay.length !== 0) {
					let outputarr = [0, 0, 0, 0, 0, 0, 0];
					let newoutputarr = [];
					for (let i in response.data.hoursPerProjectPerDay) {
						for (let j in response.data.hoursPerProjectPerDay[i]
							.details) {
							outputarr[j] += self.hoursToMinutes(
								String(
									response.data.hoursPerProjectPerDay[i]
										.details[j].hours
								)
							);
						}
					}
					for (let i in outputarr) {
						totalHoursThisWeek = totalHoursThisWeek + outputarr[i];
						newoutputarr[i] = self.minutesToHours(outputarr[i]);
					}
					self.setState({
						noDataFlag: false,
						noOfprojects:
							response.data.hoursPerProjectPerDay.length,
						allProjects: response.data.hoursPerProjectPerDay,
						Comments: response.data.supervisorComments,
						status: response.data.status,
						weekDates:
							response.data.hoursPerProjectPerDay[0].details,
						perdayHours: newoutputarr,
						totalHoursThisWeek:
							self.minutesToHours(totalHoursThisWeek),
						noRecord: false,
						showLoader: false,
					});

					if (response.data.statusId !== 3) {
						self.setState({
							disabled: true,
						});
					} else
						self.setState({
							disabled: false,
						});
				} else
					self.setState({
						noDataFlag: true,
						noRecord: true,
						showLoader: false,
					});
			});
	};
	backFunction = () => {
		return (
			this.props.UpdateNavBarItem("SpTimeSheetStatus"),
			this.props.UpdateNavBarTab("SupervisorTasks"),
			this.props.history?.push(Routes.SpTimeSheetStatus)
		);
	};
	onDevOpsClick = (values, dateP) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${Timesheet_APIs.getDevOpsTasks}?EmployeeId=${this.state.employee.value}&ProjectName=${values.taskName}&startDate=${dateP}&endDate=${dateP}`,
				{
					headers: headers,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					let devOpsData = res.data.sort((a, b) =>
						a.changedDateTime.localeCompare(b.changedDateTime)
					);
					this.setState({
						devOpsModal: true,
						devOpsTasksData: devOpsData.reverse(),
						devOpsDate: dateP,
						projectId: values.taskId,
						taskNameC: values.taskName,
					});
				}
			});
	};

	handleEmployeeChange = (value, event) => {
		this.setState(
			{
				//employee dropdown
				[event.name]: value,
			},
			() => {
				this.handleClick(2);
			}
		);
	};
	handleDatePickerChange = (value) => {
		this.setState(
			{
				//datePicker
				datePicker: value,
			},
			() => {
				this.handleClick(2);
			}
		);
	};

	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					empID = userDetails.id;
					empDesignation = userDetails.designation;
					return userDetails.designation.toString() === "4" ||
						userDetails.empRole.includes("2") ||
						userDetails.empRole.includes("5") ||
						userDetails.empRole.includes("3") ? (
						<div className="container-fluid pl-3 pr-3">
							{this.props.location.state?.showBackButton ? (
								<div className="pl-3">
									<Header
										title="Employee Timesheet"
										onClick={() => this.backFunction()}
									/>
								</div>
							) : (
								<Header title="Employee Timesheet" />
							)}

							<div className="spview-wrapper">
								<div className="bottomMargin col-md-12 mb-2  row">
									<div className="col-sm-12 p-0 titleClass">
										{this.state.selectedName}
										{this.state.weekDates.length !== 0 && (
											<>
												<span className="ml-3 vertical-line" />
												<span
													sm={5}
													className="col-md-4 col-sm-12 font-size-14 m-3 m-md-0 ml-auto  pr-0"
												>
													{moment(
														this.state.weekDates[0]
															.date
													).format(
														"dddd Do MMMM YYYY"
													) +
														" to " +
														moment(
															this.state
																.weekDates[6]
																.date
														).format(
															"dddd Do MMMM YYYY"
														)}
												</span>
												<span
													className="ml-3"
													hidden={
														this.state.noDataFlag
													}
												>
													{this.state.status && (
														<span
															className={`ml-0 status-box ${
																this.state
																	.status ===
																	"Pending" ||
																this.state
																	.status ===
																	"InProgress" ||
																this.state
																	.status ===
																	"In Progress" ||
																this.state
																	.status ===
																	"Saved"
																	? "status-pending"
																	: this.state
																			.status ===
																			"Completed" ||
																	  this.state
																			.status ===
																			"Approved" ||
																	  this.state
																			.status ===
																			"Reject"
																	? "status-approved"
																	: this.state
																			.status ===
																	  "Rejected"
																	? "status-rejected"
																	: this.state
																			.status ===
																	  "Invalid"
																	? "status-invalid"
																	: "status-draft"
															}`}
															title="Status"
														>
															{this.state.status}
														</span>
													)}
												</span>
											</>
										)}
									</div>
								</div>
								{/*DevOps Task Modal */}
								<DevOpsTasksModal
									showModal={this.state.devOpsModal}
									taskName={this.state.taskNameC}
									devOpsTasksData={this.state.devOpsTasksData}
									devOpsDate={this.state.devOpsDate}
									handleClose={() => {
										this.setState({
											...this.state,
											devOpsModal: false,
										});
									}}
								/>
								<Label className="timesheetsConfigFormLabel">
									Employee Timesheet
								</Label>
								<Row className="ml-0 spTimesheetForm mb-4">
									<div className="bottomMargin col-md-12 mb-3 row">
										<div className="col-md-3 col-sm-12 p-md-0 px-0">
											<CustomReactSelect
												placeholder="Select employee"
												className="spTimesheetDropDown"
												options={this.employees()}
												name="employee"
												id="employee"
												bsSize="sm"
												styles={
													Timesheet_Variables.react_select_style
												}
												onChange={(value, event) => {
													this.handleEmployeeChange(
														value,
														event
													);
												}}
												paginationDropDown={true}
												value={this.state.employee}
											/>
										</div>
										<div className="col-md-2 col-sm-12 datePicker-col mb-2 mb-lg-0 mb-md-0 ml-md-2 mt-2 mt-lg-0 mt-md-0 pl-2">
											<InputGroup className="inputGroup">
												<InputGroupAddon
													className="inputGroupAddon"
													addonType="prepend"
												>
													<FontAwesomeIcon
														icon={faCalendarAlt}
														className="faIcon"
														onClick={
															this.openDatepicker
														}
														color="keppel"
														size="1x"
													/>
												</InputGroupAddon>
											</InputGroup>
											<DatePicker
												showYearDropdown
												showMonthDropdown
												dateFormatCalendar=" " //for title
												value={this.state.datePicker}
												name="datePicker"
												id="datePicker"
												bsSize="sm"
												selected={this.state.datePicker}
												onChange={(value, event) => {
													this.handleDatePickerChange(
														value
													);
												}}
												onChangeRaw={(e) => {
													e.preventDefault();
												}}
												autoComplete="off"
												className="form-control form-control-sm mb-sm-2 pb-1 spEmpTimesheet-DatePicker"
												dateFormat="dd/MM/yyyy"
												disabledKeyboardNavigation
												maxDate={new Date()}
												minDate={
													this.state.employee
														.joiningDate
												}
												ref={(c) =>
													(this._calendar = c)
												}
												disabled={
													this.state.employee
														.length === 0
												}
											/>
										</div>
										<div className="ml-md-5 ml-lg-5">
											<ButtonGroup className="ml-md-4 ml-lg-4">
												<Button
													title="Previous"
													className="arrowBtn arrowButtonLeft"
													onClick={() => {
														this.handleClick(3);
													}}
												>
													<FontAwesomeIcon
														icon={faChevronLeft}
														size="1x"
													/>
												</Button>
												<Button
													title="Next"
													className="arrowBtn arrowButtonRight"
													onClick={() => {
														this.handleClick(4);
													}}
												>
													<FontAwesomeIcon
														icon={faChevronRight}
														size="1x"
													/>
												</Button>
											</ButtonGroup>
										</div>
									</div>
								</Row>

								{this.state.showLoader ? (
									<Spinner color="secondary" />
								) : (
									<div hidden={this.state.noDataFlag}>
										<div>
											<div>
												<span className="publicHolidayColor"></span>
												<span className="font-small font-weight-light pl-1">
													Public Holiday
												</span>
											</div>

											<div className="mb-4">
												<span className="leaveColor"></span>
												<span className="font-small font-weight-light pl-1">
													Employee Personal Leave
												</span>
											</div>
										</div>
										<Table className="empTable" responsive>
											<thead className="thead">
												<tr className="row0">
													<th
														style={{
															width: "17%",
															paddingBottom:
																"26px",
														}}
													>
														Task
													</th>
													{this.state.weekDates.map((day, key) => {
      const workstationForDate = this.getWorkstationForDate(day.date);

      return (
        <th key={key} className="pl-0">
          <div>
            {moment(day.date).format("dddd")}
			{workstationForDate === "Work From Home" ? (
              <Image
                src={homeIcon}
                className="homeIcon"
                alt="home"
                title="Work from Home"
              />
            ) : (
              workstationForDate === "Work From Office" ? (
                <Image
                  src={officeIcon}
                  className="officeIcon"
                  alt="office"
                  title="Work from Office"
                />
              ) : null
            )}
          </div>
          <div className="th-date">
            {moment(day.date).format("MMMM Do")}
          </div>
        </th>
      );
    })}
												</tr>
											</thead>
											<tbody className="sp-tbody">
												<tr className="row3">
													<th>Hours this week</th>
													{this.state.perdayHours.map(
														(element, index) => {
															return (
																<td
																	className="font-size-22 pl-0 border-bottom-0"
																	key={index}
																>
																	<span
																		title={
																			(this
																				.state
																				.weekHolidayData[
																				index
																			]
																				?.isCalendarHoliday &&
																				"Public Holiday") ||
																			(this
																				.state
																				.weekHolidayData[
																				index
																			]
																				?.isLeave &&
																				"Employee Personal Leave")
																		}
																		className={`font-size-22 pl-0 border-bottom-0 ${
																			this
																				.state
																				.weekHolidayData[
																				index
																			]
																				?.isCalendarHoliday
																				? "spHolidayIndication"
																				: null
																		}
																		${this.state.weekHolidayData[index]?.isLeave ? "spLeaveIndication" : null}`}
																	>
																		{
																			element
																		}
																	</span>
																</td>
															);
														}
													)}
												</tr>
												<Comment
													taskName={
														this.state.taskName
													}
													commentDate={
														this.state.commentDate
													}
													empComments={
														this.state.empComments
													}
													ref={this.CommentRef}
												></Comment>

												{this.state.allProjects.map(
													(d, index) => {
														return (
															<tr
																className={
																	index %
																		2 ===
																	0
																		? "row1"
																		: "row2"
																}
																id="data"
																key={index}
															>
																<td
																	style={{
																		width: "12%",
																	}}
																>
																	<label className="taskName-font mb-0">
																		{
																			d.taskName
																		}
																	</label>
																</td>

																{d.details.map(
																	(
																		item,
																		key
																	) => {
																		return (
																			<td
																				key={
																					key
																				}
																				className="pl-0 pr-0"
																			>
																				<div className="d-flex">
																					<input
																						className="hours-span "
																						value={
																							item.hours
																						}
																						readOnly
																					/>

																					{item.comments ===
																					"" ? (
																						<img
																							title="Comments"
																							src={
																								cmntImg
																							}
																							alt="Comment"
																							className="faCommentBtn pl-1"
																						/>
																					) : (
																						<img
																							title="Comment"
																							key={
																								key
																							}
																							src={
																								filledCommentImg
																							}
																							alt="Comment"
																							className="faCommentBtn pl-1"
																							onClick={() =>
																								this.onCommentClick(
																									d.taskName,
																									item.date,
																									item.comments
																								)
																							}
																						/>
																					)}
																				</div>
																				{item.devopsHours >
																					0 && (
																					<div
																						className="my-1 mx-0 mx-md-2 mx-lg-4"
																						style={{
																							color: "#616161",
																						}}
																					>
																						<span
																							className="devOpsHoursLink"
																							onClick={() =>
																								this.onDevOpsClick(
																									d,
																									item.date,
																									item.comments,
																									false
																								)
																							}
																						>
																							{devOpsHoursToTime(
																								item.devopsHours
																							)}
																						</span>
																					</div>
																				)}
																			</td>
																		);
																	}
																)}
															</tr>
														);
													}
												)}
											</tbody>
										</Table>
										<Row className="mt-2 mb-3">
											<Col sm={9}>
												<span className="font-size-11">
													TOTAL REPORTED HOURS WEEKLY
												</span>
												<span className="timeSpan">
													{
														this.state
															.totalHoursThisWeek
													}
												</span>
											</Col>
										</Row>

										<form>
											{this.state
												.rejectionReasonIfAny && (
												<>
													<p className="spComments pb-2 pt-2">
														Employee Request for
														rejection
													</p>

													<Input
														type="textarea"
														name="rejectionReason"
														id="rejectionReason"
														value={
															this.state
																.rejectionReasonIfAny
														}
														readOnly
														maxLength="500"
													/>
												</>
											)}

											<p className="spComments pb-2 pt-2">
												Supervisor's Comments
											</p>

											<Input
												type="textarea"
												name="Comments"
												id="Comments"
												onChange={(value) =>
													this.handleCommentsChange(
														value,
														1
													)
												}
												value={this.state.Comments}
												disabled={this.state.disabled}
												maxLength="500"
											/>
											{this.state.CommentsErr && (
												<div className="input-feedback">
													{this.state.CommentsErr}
												</div>
											)}
											<FormGroup
												row
												className="btns mr-1"
											>
												<Button
													type="button"
													id="rejectBtn"
													className="delete-btn leftBtn"
													onClick={() =>
														this.handleClick(1)
													}
													disabled={
														this.state.disabled
													}
													style={{
														cursor: this.state
															.disabled
															? "default"
															: "pointer",
													}}
												>
													Reject
												</Button>

												<Button
													className="approve-btn"
													disabled={
														this.state.disabled
													}
													onClick={() =>
														this.handleSubmit()
													}
													style={{
														cursor: this.state
															.disabled
															? "default"
															: "pointer",
													}}
												>
													Accept
												</Button>
											</FormGroup>
										</form>
									</div>
								)}
							</div>
							{this.state.noRecord && (
								<span hidden={!this.state.noRecord}>
									No Record Against Given Date
								</span>
							)}
						</div>
					) : (
						<Redirect to="/MyDashboard" />
					);
				}}
			</UserConsumer>
		);
	}
}
const mapDispatchToProps = {
	UpdateNavBarItem,
	UpdateNavBarTab,
};
export default connect(null, mapDispatchToProps)(SpTimesheet);
